// mockGSCData.js
// Mock data for GSC Top Performers (queries and pages)

export const mockGSCTopQueriesResponse = {
  status: "success",
  message: "Top 10 queries for last 6 months",
  data: {
    queries: [
      {
        rank: 1,
        query: "scaletime",
        clicks: 65,
        impressions: 117,
        ctr: 64.19,
        position: 1,
        percentage_of_clicks: 27.78
      },
      {
        rank: 2,
        query: "project manager performance review examples",
        clicks: 37,
        impressions: 156,
        ctr: 25.33,
        position: 1.5,
        percentage_of_clicks: 15.81
      },
      {
        rank: 3,
        query: "client interview questions",
        clicks: 29,
        impressions: 337,
        ctr: 9.13,
        position: 3,
        percentage_of_clicks: 12.39
      },
      {
        rank: 4,
        query: "feedback for project manager",
        clicks: 27,
        impressions: 80,
        ctr: 45.25,
        position: 2.2,
        percentage_of_clicks: 11.54
      },
      {
        rank: 5,
        query: "client interview questions and answers",
        clicks: 23,
        impressions: 121,
        ctr: 28.2,
        position: 4,
        percentage_of_clicks: 9.83
      },
      {
        rank: 6,
        query: "project management performance review examples",
        clicks: 12,
        impressions: 39,
        ctr: 63.22,
        position: 1.8,
        percentage_of_clicks: 5.13
      },
      {
        rank: 7,
        query: "project management sop",
        clicks: 12,
        impressions: 95,
        ctr: 13.82,
        position: 3.2,
        percentage_of_clicks: 5.13
      },
      {
        rank: 8,
        query: "project manager performance review template",
        clicks: 10,
        impressions: 39,
        ctr: 36.14,
        position: 2.8,
        percentage_of_clicks: 4.27
      },
      {
        rank: 9,
        query: "client round interview questions",
        clicks: 10,
        impressions: 62,
        ctr: 20.82,
        position: 3.7,
        percentage_of_clicks: 4.27
      },
      {
        rank: 10,
        query: "sample good feedback for project manager from employee",
        clicks: 9,
        impressions: 20,
        ctr: 50.83,
        position: 2.6,
        percentage_of_clicks: 3.85
      }
    ],
    period: {
      start_date: "2025-08-01",
      end_date: "2026-01-08",
      months: 6,
      include_current: true
    },
    metadata: {
      total_queries: 10,
      total_clicks: 234,
      total_impressions: 1066,
      avg_ctr: 21.95,
      generated_at: "2026-01-08T23:17:17.404491",
      data_source: "gsc_monthly"
    }
  },
  query_info: {
    timestamp: "2026-01-08T23:17:17.404559",
    authenticated_user: null,
    months_requested: 6,
    include_current_month: true,
    limit: 10
  }
};

export const mockGSCTopPagesResponse = {
  status: "success",
  message: "Top 10 pages for last 6 months",
  data: {
    pages: [
      {
        rank: 1,
        page: "https://scaletime.co/blog/project-manager-performance-review-examples",
        clicks: 1803,
        impressions: 81923,
        ctr: 2.52,
        position: 19.6,
        percentage_of_clicks: 58.41
      },
      {
        rank: 2,
        page: "https://scaletime.co/blog/project-management-sop-example",
        clicks: 404,
        impressions: 35487,
        ctr: 1.12,
        position: 15.2,
        percentage_of_clicks: 13.09
      },
      {
        rank: 3,
        page: "https://scaletime.co/blog/client-interview-questions-insights",
        clicks: 362,
        impressions: 29082,
        ctr: 1.33,
        position: 12,
        percentage_of_clicks: 11.73
      },
      {
        rank: 4,
        page: "https://scaletime.co/blog/write-a-sop-5xfaster-with-chatgpt",
        clicks: 168,
        impressions: 11939,
        ctr: 1.77,
        position: 13.4,
        percentage_of_clicks: 5.44
      },
      {
        rank: 5,
        page: "https://scaletime.co/blog/google-sites-intranet",
        clicks: 130,
        impressions: 16861,
        ctr: 1.39,
        position: 21.4,
        percentage_of_clicks: 4.21
      },
      {
        rank: 6,
        page: "https://scaletime.co/",
        clicks: 86,
        impressions: 1169,
        ctr: 7.61,
        position: 12.5,
        percentage_of_clicks: 2.79
      },
      {
        rank: 7,
        page: "https://scaletime.co/blog/mad-men-advertising-jobs-then-now",
        clicks: 38,
        impressions: 1943,
        ctr: 2.52,
        position: 11.7,
        percentage_of_clicks: 1.23
      },
      {
        rank: 8,
        page: "https://scaletime.co/blog/effective-tips-for-how-to-assess-employee-workload",
        clicks: 35,
        impressions: 2628,
        ctr: 2.08,
        position: 31.9,
        percentage_of_clicks: 1.13
      },
      {
        rank: 9,
        page: "https://scaletime.co/blog/client-folders",
        clicks: 32,
        impressions: 1665,
        ctr: 2.11,
        position: 14,
        percentage_of_clicks: 1.04
      },
      {
        rank: 10,
        page: "https://scaletime.co/blog/smart-goals-for-project-managers",
        clicks: 29,
        impressions: 3847,
        ctr: 0.83,
        position: 29.9,
        percentage_of_clicks: 0.94
      }
    ],
    period: {
      start_date: "2025-08-01",
      end_date: "2026-01-08",
      months: 6,
      include_current: true
    },
    metadata: {
      total_pages: 10,
      total_clicks: 3087,
      total_impressions: 186544,
      avg_ctr: 1.65,
      generated_at: "2026-01-08T23:18:22.254475",
      data_source: "gsc_monthly"
    }
  },
  query_info: {
    timestamp: "2026-01-08T23:18:22.254525",
    authenticated_user: null,
    months_requested: 6,
    include_current_month: true,
    limit: 10
  }
};

// Helper function to get mock data based on dimension type
export const getMockGSCData = (dimensionType = 'query') => {
  if (dimensionType === 'page') {
    return mockGSCTopPagesResponse.data;
  }
  return mockGSCTopQueriesResponse.data;
};

// =============================================================================
// GA4 ACTIVE USERS MOCK DATA
// =============================================================================

export const mockGA4ActiveUsersResponse = {
  status: "success",
  message: "Active users by channel for last 6 months",
  data: {
    periods: [
      "Aug 2025",
      "Sep 2025",
      "Oct 2025",
      "Nov 2025",
      "Dec 2025",
      "Jan 2026"
    ],
    channels: {
      "Direct": [397, 658, 1244, 2004, 1906, 195],
      "Organic Search": [888, 994, 984, 942, 644, 52],
      "Organic Social": [4, 26, 1, 1, 10, 2],
      "Paid Social": [1, 0, 1, 0, 0, 1],
      "Referral": [43, 50, 55, 46, 26, 1],
      "Unassigned": [149, 13, 23, 53, 61, 1],
      "Organic Video": [0, 0, 0, 0, 2, 0]
    },
    totals: [1482, 1741, 2308, 3046, 2649, 252],
    channel_stats: [
      {
        channel: "Direct",
        total_users: 6404,
        avg_users_per_month: 1067.33,
        percentage_of_total: 55.79
      },
      {
        channel: "Organic Search",
        total_users: 4504,
        avg_users_per_month: 750.67,
        percentage_of_total: 39.24
      },
      {
        channel: "Unassigned",
        total_users: 300,
        avg_users_per_month: 50,
        percentage_of_total: 2.61
      },
      {
        channel: "Referral",
        total_users: 221,
        avg_users_per_month: 36.83,
        percentage_of_total: 1.93
      },
      {
        channel: "Organic Social",
        total_users: 44,
        avg_users_per_month: 7.33,
        percentage_of_total: 0.38
      },
      {
        channel: "Paid Social",
        total_users: 3,
        avg_users_per_month: 0.5,
        percentage_of_total: 0.03
      },
      {
        channel: "Organic Video",
        total_users: 2,
        avg_users_per_month: 0.33,
        percentage_of_total: 0.02
      }
    ],
    metadata: {
      start_date: "2025-08-01",
      end_date: "2026-01-08",
      months_requested: 6,
      months_returned: 6,
      unique_channels: 7,
      total_active_users: 11478,
      generated_at: "2026-01-08T23:26:06.208635",
      data_source: "ga4_monthly_by_channel"
    }
  },
  query_info: {
    timestamp: "2026-01-08T23:26:06.208707",
    authenticated_user: null,
    months_requested: 6,
    include_current_month: true
  }
};

// Helper function to get GA4 mock data
export const getMockGA4ActiveUsers = () => {
  return mockGA4ActiveUsersResponse.data;
};